define(
    [
        'flightjs',
    ],

    function(flight) {
        'use strict';

        return flight.component(adminBar);

        function adminBar() {

            this.after('initialize', function () {
                this.on(document, 'brandContainer.ui.adminBarToggleRequested', this.toggleAdminBar);
                this.loadState();
            });

            this.showAdminBar = function () {
                this.$node.removeAttr('data-hidden');
                this.saveState();
                this.trigger('brandContainer.ui.adminBarShown', {});
            };

            this.hideAdminBar = function () {
                this.$node.attr('data-hidden', true);
                this.saveState();
                this.trigger('brandContainer.ui.adminBarHidden', {});
            };

            this.toggleAdminBar = function () {
                if (!this.$node.attr('data-hidden')) {
                    this.hideAdminBar();
                } else {
                    this.showAdminBar();
                }

                this.scrollToTop();
            };

            this.scrollToTop = function () {
                $('body').animate({ scrollTop: 0 }, 'fast');
            };

            this.saveState = function () {
                var state = this.$node.attr('data-hidden');
                if (state) {
                    document.cookie = 'admin:bar=hide; path=/';
                } else {
                    document.cookie = 'admin:bar=show; path=/';
                }
            };

            this.loadState = function () {
                if (!!~document.cookie.indexOf('admin:bar=hide')) {
                    this.hideAdminBar();
                } else {
                    this.showAdminBar();
                }
            };
        }
    }
);



/** WEBPACK FOOTER **
 ** ./~/@99designs/brand-container/lib/ui/admin-bar.js
 **/